export const quoteServicePresets = Object.freeze([
  { id: 'study-power-balance', category: 'Études', label: 'Bilan de puissance BT', description: 'Établissement du bilan de puissance', unit: 'U', hours: 20, laborProfileCode: 'ETUDES' },
  { id: 'study-calc-cfo', category: 'Études', label: 'Note de calcul CFO', description: 'Note de calcul électrique CFO', unit: 'U', hours: 40, laborProfileCode: 'ETUDES' },
  { id: 'study-lighting', category: 'Études', label: "Note de calcul d'éclairement", description: "Calcul d'éclairement et note justificative", unit: 'U', hours: 16, laborProfileCode: 'ETUDES' },
  { id: 'draw-implant-cfo', category: 'Plans', label: "Plan d'implantation CFO", description: "Plan d'implantation CFO", unit: 'U', hours: 16, laborProfileCode: 'ETUDES' },
  { id: 'draw-implant-cfa', category: 'Plans', label: "Plan d'implantation CFA", description: "Plan d'implantation CFA", unit: 'U', hours: 16, laborProfileCode: 'ETUDES' },
  { id: 'draw-single-line', category: 'Schémas', label: 'Schéma unifilaire', description: 'Établissement des schémas unifilaires', unit: 'U', hours: 16, laborProfileCode: 'ETUDES' },
  { id: 'synoptic', category: 'Schémas', label: 'Synoptique', description: 'Établissement du synoptique', unit: 'U', hours: 8, laborProfileCode: 'ETUDES' },
  { id: 'cable-book', category: 'EXE', label: 'Carnet de câbles', description: 'Établissement du carnet de câbles', unit: 'U', hours: 12, laborProfileCode: 'ETUDES' },
  { id: 'reserve-plan', category: 'EXE', label: 'Plan de réservations', description: 'Établissement du plan de réservations', unit: 'U', hours: 8, laborProfileCode: 'ETUDES' },
  { id: 'doe', category: 'DOE', label: 'Constitution du DOE', description: 'Compilation, contrôle et constitution du DOE', unit: 'U', hours: 16, laborProfileCode: 'ETUDES' },
]);

const DEFAULT_PROFILE_RATES = Object.freeze({ ETUDES: 60, ELECTRICIEN: 34, PRODUCTION: 37, AUTOMATICIEN: 40, APPRENTI: 33, CHEF_CHANTIER: 38 });

const parameterRate = (editor, profileCode) => {
  const parameter = (editor.versionParameters || []).find((item) => item.parameterCode === `laborRate.${profileCode}`);
  return parameter?.valueNumber ?? DEFAULT_PROFILE_RATES[profileCode] ?? editor.defaultLaborRate ?? 0;
};

export const lineFromServicePreset = (preset, editor = {}) => {
  const rate = parameterRate(editor, preset.laborProfileCode);
  return ({
  description: preset.description || preset.label,
  lineType: 'service',
  quantity: 1,
  unit: preset.unit || 'Ens',
  estimatedHours: preset.hours || 0,
  laborRate: rate,
  laborItems: [{
    id: `labor-preset-${Date.now()}`,
    profileCodeSnapshot: preset.laborProfileCode,
    profileLabelSnapshot: preset.laborProfileCode === 'ETUDES' ? 'Études' : preset.laborProfileCode,
    resourceQuantity: 1,
    unitHours: preset.hours || 0,
    costHourlyRateSnapshot: rate,
  }],
  vatRate: editor.defaultVatRate ?? 20,
  servicePresetId: preset.id,
  servicePresetLabel: preset.label,
});
};
